import React from 'react';
import { number, oneOfType, string } from 'prop-types';
import Fade from '@material-ui/core/Fade';
import DateTime, { MONTH_YEAR } from '../../../../../../DateTime';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

// @ts-expect-error ts-migrate(2417) FIXME: Type '{ coverageExpiration: Validator<string>; out... Remove this comment to see the full error message
class OutOfPocketMax extends Base {
  static propTypes = {
    coverageExpiration: string.isRequired,
    outOfPocketMax: oneOfType([number, string]).isRequired,
  };

  static isVisible = ({ coverageExpiration, outOfPocketMax }: any) =>
    !isEmpty(coverageExpiration) && !isEmpty(outOfPocketMax);

  icon = '/images/insurance_tutorial/10_max.svg';

  render = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'coverageExpiration' does not exist on ty... Remove this comment to see the full error message
    const { coverageExpiration, outOfPocketMax } = this.props;
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Meet your max</H2>

            <P>
              Worst-case scenario, there's a maximum amount you'll have to pay out of pocket. For
              your plan, that's <b>${outOfPocketMax}</b>. Once you've hit that amount, your
              insurance will... finally... fully cover your care through{' '}
              <b>{DateTime.format(coverageExpiration)(MONTH_YEAR)}</b>.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default OutOfPocketMax;
